import { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";
import { SITE_URL } from "../../config/site";
import { useCart } from "../../cart/CartContext";
import { CartCheckout } from "../../api/CartCheckout";

import "./CartPage.css";

export default function CartPage() {
  const [email, setEmail] = useState("");
  const [checkoutError, setCheckoutError] = useState("");
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const {
    items,
    totals,
    updateQuantity,
    removeItem,
    clearCart,
  } = useCart();
  const hasItems = items.length > 0;

  const handleCheckout = async () => {
    setCheckoutError("");

    if (!email.trim()) {
      setCheckoutError("Introduce el email del pedido.");
      return;
    }

    setCheckoutLoading(true);

    try {
      const data = await CartCheckout({
        email: email.trim(),
        items,
        totals,
      });

      window.location.href = data.checkoutUrl;
    } catch (error) {
      setCheckoutError(error.message || "No se pudo iniciar el pago.");
      setCheckoutLoading(false);
    }
  };

  const renderOptions = (options) => {
    const optionList = Object.values(options || {});

    if (!optionList.length) {
      return null;
    }

    return (
      <dl className="cart-item-options">
        {optionList.map((option) => (
          <div key={`${option.label}-${option.value}`}>
            <dt>{option.label}</dt>
            <dd>{option.valueLabel || option.value}</dd>
          </div>
        ))}
      </dl>
    );
  };

  const renderAssets = (assets) => {
    if (!assets?.length) {
      return null;
    }

    return (
      <p className="cart-item-assets">
        {assets.length} imagen{assets.length === 1 ? "" : "es"} incluida
        {assets.length === 1 ? "" : "s"} en el pedido
      </p>
    );
  };

  return (
    <>
      <SEO
        title="Carrito | Imalandia"
        description="Revisa los productos de tu pedido antes de continuar con el pago."
        canonical={`${SITE_URL}/carrito`}
        noindex
      />

      <Header />

      <main className="cart-page">
        <section className="cart-header">
          <p>Pedido</p>
          <h1>Carrito</h1>
        </section>

        {!hasItems && (
          <section className="cart-empty">
            <h2>Tu carrito esta vacio</h2>

            <p>
              Anade imanes, marcos o accesorios desde la tienda para preparar
              tu pedido.
            </p>

            <Link to="/#tienda" className="cart-primary-link">
              Volver a la tienda
            </Link>
          </section>
        )}

        {hasItems && (
          <section className="cart-shell">
            <div className="cart-items">
              {items.map((item) => (
                <article key={item.cartItemId} className="cart-item">
                  <div className="cart-item-main">
                    <h2>{item.productName}</h2>
                    <p>{item.category}</p>
                    {renderOptions(item.options)}
                    {renderAssets(item.assets)}
                  </div>

                  <div className="cart-item-controls">
                    <label>
                      Cantidad
                      <input
                        type="number"
                        min="1"
                        value={item.quantity}
                        onChange={(event) =>
                          updateQuantity(
                            item.cartItemId,
                            Number(event.target.value)
                          )
                        }
                      />
                    </label>

                    <strong>{item.subtotalPrice.toFixed(2)} EUR</strong>

                    <button
                      type="button"
                      onClick={() => removeItem(item.cartItemId)}
                    >
                      Eliminar
                    </button>
                  </div>
                </article>
              ))}
            </div>

            <aside className="cart-summary">
              <h2>Resumen</h2>

              <label className="cart-email-field">
                Email para el pedido
                <input
                  type="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </label>

              <div className="cart-summary-row">
                <span>Productos</span>
                <strong>{totals.subtotalPrice.toFixed(2)} EUR</strong>
              </div>

              <div className="cart-summary-row">
                <span>Envio</span>
                <strong>{totals.shippingPrice.toFixed(2)} EUR</strong>
              </div>

              <div className="cart-summary-row">
                <span>Total</span>
                <strong>{totals.totalPrice.toFixed(2)} EUR</strong>
              </div>

              <button
                type="button"
                className="cart-checkout-button"
                disabled={checkoutLoading}
                onClick={handleCheckout}
              >
                {checkoutLoading ? "Preparando pago..." : "Continuar al pago"}
              </button>

              {checkoutError && (
                <p className="cart-checkout-error">{checkoutError}</p>
              )}

              <button
                type="button"
                className="cart-clear-button"
                onClick={clearCart}
              >
                Vaciar carrito
              </button>
            </aside>
          </section>
        )}
      </main>

      <Footer />
    </>
  );
}
